import {
  ApiSite,
  Divider,
  FormGroup,
  Grid,
  PageContent,
} from '@mss/mss-component-library';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'jsx';

type Props = {
  status: ApiSite;
};

function Settings({ status }: Props) {
  const [t] = useTranslation(['configuration', 'common']);
  const { mssVersions } = useContext(AppContext);

  return (
    <>
      <PageContent title={t('Site configuration')}>
        <Grid.Row>
          <Grid.Col width={4}>
            <FormGroup
              label={t('Site name')}
              input={<span>{status.name}</span>}
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup label={t('Site ID')} input={<span>{status.id}</span>} />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('Site focal point')}
              input={<span>{status.focal_point}</span>}
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('GPS Coordinates')}
              input={
                <span>
                  {status.latitude}, {status.longitude}
                </span>
              }
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('Timezone')}
              input={<span>{status.timezone}</span>}
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('Language')}
              input={<span>{status.language}</span>}
            />
          </Grid.Col>
          <Grid.Col width={4}>
            <FormGroup
              label={t('Customer')}
              input={<span>{status.customer_name || '-'}</span>}
            />
          </Grid.Col>
          <Grid.Col width={12}>
            <FormGroup
              label={t('Description')}
              input={<span>{status.description}</span>}
            />
          </Grid.Col>
        </Grid.Row>
      </PageContent>
      <Divider />
      <PageContent className="mt-12" title={t('Packages')}>
        <ul className="pl-6">
          <li>
            {t('Site API')} @{' '}
            <strong>{mssVersions['mss_site_api_full']}</strong>
          </li>
          <li>
            {t('Site client')} @{' '}
            <strong>{mssVersions['mss_site_client']}</strong>
          </li>
          <li>
            {t('Celery')} @ <strong>{mssVersions['celery']}</strong>
          </li>
          <li>
            {t('Redis')} @ <strong>{mssVersions['redis']}</strong>
          </li>
          <li>
            {t('React')} @ <strong>{mssVersions['react']}</strong>
          </li>
        </ul>
      </PageContent>
    </>
  );
}

export default Settings;
